/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../utility/Constant";

const ContactContentPage = () => {
  const { contactApi } = apiPath;
  const { clientContact } = clientSideUrl;
  const [apiData, apiLoading] = useFetch(contactApi);
  const [filteredData, setFilteredData] = useState();

  useEffect(() => {
    setFilteredData(apiData?.filter((item) => item.slug === "headquarters"));
  }, [apiData]);

  if (apiLoading) {
    return <Loading />;
  }

  const { country, address, phone, email, _id } = filteredData[0] ?? {};

  const data = [
    {
      elementType: "input",
      label: "country",
      type: "Text",
      name: "country",
      defaultValue: country,
      required: false,
    },
    {
      elementType: "textField",
      label: "address",
      type: "Text",
      name: "address",
      defaultValue: address,
      required: false,
    },
    {
      elementType: "input",
      label: "phone",
      type: "Text",
      name: "phone",
      defaultValue: phone,
      required: false,
    },
    {
      elementType: "input",
      label: "email",
      type: "Text",
      name: "email",
      defaultValue: email,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(contactApi, data, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-8 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientContact}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">
        <h1 className="md:ml-8 font-bold text-2xl mt-4  uppercase">
          Reach us section
        </h1>
        {_id && <GlobalForm data={data} update={update} />}
      </div>
    </div>
  );
};

export default ContactContentPage;
